(function() {
    var GoogleMapsLoader = require('google-maps');
	GoogleMapsLoader.KEY = "AIzaSyAkElDe-mohuBZVK0zgxSNIYOliuBsZJ1k";

    GoogleMapsLoader.load(function(google) {

        var map;

        function initialize() {
            var glat = 42.791502;
            glong = 0.5910450000000083;

            var mapOptions = {
                zoom: 17,
                scrollwheel: false,
                center: new google.maps.LatLng(glat, glong),
                styles: [{
                    "featureType": "poi.business",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }]
            };
            map = new google.maps.Map(document.getElementById('maps'), mapOptions);

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(glat, glong),
                map: map,
                icon: '/bundles/sitefrontend/img/marker.png'
            });
        }
        google.maps.event.addDomListener(window, 'load', initialize);
    });
})();
